import { render, staticRenderFns } from "./DescribeShippment.vue?vue&type=template&id=d23f394c&scoped=true"
import script from "./DescribeShippment.vue?vue&type=script&lang=js"
export * from "./DescribeShippment.vue?vue&type=script&lang=js"
import style0 from "./DescribeShippment.vue?vue&type=style&index=0&id=d23f394c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23f394c",
  null
  
)

export default component.exports